import * as React from 'react'
import { Card, Col, Row, Icon } from 'antd'
import AnimatedNumber from 'react-animated-number'
import CardTitle from 'widget/CardTitle'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'


class DashBoard extends React.Component<any, any> {

  constructor(props) {
    super(props)
    this.handleRefreshClick = this.handleRefreshClick.bind(this)
  }
  componentDidMount() {
    this.getStatistics()
  }

  getStatistics() {
    this.props.getMyOrderStatistics()
    this.props.getMySaleStatistics()
    this.props.getShopSaleStatistics()
    this.props.getShopOrderStatistics()
  }

  formatValue = value => `${(value * 1).toFixed(2)}`;

  handleRefreshClick() {
    window.location.reload()
  }

  render() {
    const { mySales, myOrder, shopOrder, shopSales, userId } = this.props
    const isShowShopSales = JSON.stringify(shopSales) === `{"result":""}` ? false : true
    const mySaleStatistics = [
      { title: "今日订单量", body: "月订单量", subTitle: mySales.orderNumToday, monthly: mySales.orderNumMonth, nounit: true, decimal: 0, subTitleColor: "#3eb3e8" },
      { title: "今日销售额", body: "月销售额", subTitle: mySales.paymentTotalToday, monthly: mySales.paymentTotalMonth, subTitleColor: "#6e8cd7" },
      { title: "今日毛利润", body: "月毛利润", subTitle: mySales.profitToday, monthly: mySales.profitMonth, subTitleColor: "#41cac0" },
      // { title: "今日退款", body: "月退款", subTitle: mySales.refundTotalToday, monthly: mySales.refundTotalMonth, subTitleColor: "#f4b53a" },
    ]

    const myOrderStatistics = [
      { subTitle: "未完结加急订单", title: myOrder.weiWanJie, to: `/app/orderList?orderstatus=2&saler=${userId}` },
      { subTitle: "待完善", title: myOrder.yiLou, to: `/app/orderList?orderstatus=3&saler=${userId}` },
      { subTitle: "待审核", title: myOrder.daiShenHe, to: `/app/orderList?orderstatus=4&saler=${userId}` },
      { subTitle: "满员订单", title: myOrder.manYuan, to: `/app/orderList?orderstatus=5&saler=${userId}` },
      { subTitle: "退订失败", title: myOrder.tuiDingShiBai, to: `/app/orderList?orderstatus=6&saler=${userId}` },
      { subTitle: "异常订单", title: myOrder.yiChang, to: `/app/orderList?orderstatus=7&saler=${userId}` },
      { subTitle: "占位订单", title: myOrder.zhanWei, to: `/app/orderList?orderstatus=8&saler=${userId}` }
    ]

    const shopSaleStatistics = [
      { title: "今日订单量", body: "月订单量", subTitle: shopSales.orderNumToday, monthly: shopSales.orderNumMonth, nounit: true, decimal: 0, subTitleColor: "#3eb3e8" },
      { title: "今日销售额", body: "月销售额", subTitle: shopSales.paymentTotalToday, monthly: shopSales.paymentTotalMonth, subTitleColor: "#6e8cd7" },
      { title: "今日毛利润", body: "月毛利润", subTitle: shopSales.profitToday, monthly: shopSales.profitMonth, subTitleColor: "#41cac0" },
      // { title: "今日退款", body: "月退款", subTitle: shopSales.refundTotalToday, monthly: shopSales.refundTotalMonth, subTitleColor: "#f4b53a" },
    ]

    const shopOrderStatistics = [
      { title: "未完结加急订单", subTitle: shopOrder.weiWanJie, to: `/app/orderList?orderstatus=2` },
      { title: "待完善", subTitle: shopOrder.yiLou, to: `/app/orderList?orderstatus=3` },
      { title: "待审核", subTitle: shopOrder.daiShenHe, to: `/app/orderList?orderstatus=4` },
      { title: "满员订单", subTitle: shopOrder.manYuan, to: `/app/orderList?orderstatus=5` },
      { title: "退订失败", subTitle: shopOrder.tuiDingShiBai, to: `/app/orderList?orderstatus=6` },
      { title: "异常订单", subTitle: shopOrder.yiChang, to: `/app/orderList?orderstatus=7` },
      { title: "占位订单", subTitle: shopOrder.zhanWei, to: `/app/orderList?orderstatus=8` }
    ]

    return (
      <div className="dashboard">
        <a style={{ float: "right" }} onClick={this.handleRefreshClick}><Icon type="reload" style={{ fontSize: 15 }} />刷新数据</a>
        <div style={{ margin: 24, fontSize: 16 }}>我的销售</div>
        <Row gutter={16}>
          {mySaleStatistics.map((data: any, i: any) => {
            const decimal = typeof data.decimal === 'undefined' ? 2 : data.decimal
            const title = `${data.title} ${data.nounit ? "" : "(元)"}`
            return (
              <Col key={i} span={6}>
                <Card
                  title={
                    <CardTitle
                      title={title}
                      subTitle={<AnimatedNumber
                        value={Number(data.subTitle) || 0}
                        formatValue={value => `${(value * 1).toFixed(decimal)}`}
                        duration={800}
                      />}
                      subTitleClassName="dashboard-card-subTitle"
                      subTitleColor={data.subTitleColor}
                    />}
                  bordered={false}
                >
                  {data.body} {data.monthly} {data.nounit ? "" : "(元)"}
                </Card>
              </Col>
            )
          })}
        </Row>
        <Row className="dashboard-row" >
          <Card title="我的订单" extra={<Link target="_blank" to={`/app/orderList?orderstatus=1&saler=${userId}`}>查看</Link>} bordered={false} >
            <Row gutter={16}>
              {myOrderStatistics.map((data: any, i: any) => {
                return (
                  <Col key={i} span={3}>
                    <Link target="_blank" to={data.to}>
                      <Card
                        title={
                          <CardTitle title={data.title} subTitleColor="#bbbbbb" subTitle={data.subTitle} />}
                        headStyle={{ backgroundColor: "#f8f8f8", textAlign: "center" }}
                        bodyStyle={{ textAlign: "center", padding: 10 }}
                      >
                        <a>查看</a>
                      </Card>
                    </Link>
                  </Col>
                )
              })}
            </Row>
          </Card>
        </Row>
        <div style={{ margin: 24, marginTop: 50, fontSize: 16 }}>全店销售</div>
        {
          isShowShopSales &&
          <Row gutter={16}>
            {shopSaleStatistics.map((data: any, i: any) => {
              const decimal = typeof data.decimal === 'undefined' ? 2 : data.decimal
              const title = `${data.title} ${data.nounit ? "" : "(元)"}`
              return (
                <Col key={i} span={6}>
                  <Card
                    title={
                      <CardTitle
                        title={title}
                        subTitle={<AnimatedNumber
                          formatValue={value => `${(value * 1).toFixed(decimal)}`}
                          duration={800}
                          value={data.subTitle}
                        />}
                        subTitleClassName="dashboard-card-subTitle"
                        subTitleColor={data.subTitleColor}
                      />}
                    bordered={false}
                  >
                    {data.body} {data.monthly} {data.nounit ? "" : "(元)"}
                  </Card>
                </Col>
              )
            })}
          </Row>
        }
        <Row className="dashboard-row">
          <Card title="全部订单" extra={<Link target="_blank" to={"/app/orderList"}>查看</Link>} bordered={false} >
            <Row gutter={16}>
              {shopOrderStatistics.map((data: any, i: any) => {
                return (
                  <Col key={i} span={3}>
                    <Link target="_blank" to={data.to}>
                      <Card
                        title={
                          <CardTitle title={data.title} subTitleColor="#bbbbbb" subTitle={data.subTitle} />}
                        headStyle={{ backgroundColor: "#f8f8f8", textAlign: "center" }}
                        bodyStyle={{ textAlign: "center", padding: 10 }}
                      >
                        <a>查看</a>
                      </Card>
                    </Link>
                  </Col>
                )
              })}
            </Row>
          </Card>
        </Row>
      </div>
    )
  }
}

const mapStateDashboard = state => ({
  myOrder: state.dashboard.myOrder,
  mySales: state.dashboard.mySales,
  shopOrder: state.dashboard.shopOrder,
  shopSales: state.dashboard.shopSales,
  userId: state.userInfo.user.id
})


const mapDispatchDashboard = dispatch => ({
  getMyOrderStatistics: dispatch.dashboard.getMyOrderStatistics,
  getMySaleStatistics: dispatch.dashboard.getMySaleStatistics,
  getShopSaleStatistics: dispatch.dashboard.getShopSaleStatistics,
  getShopOrderStatistics: dispatch.dashboard.getShopOrderStatistics
})

export default connect(mapStateDashboard, mapDispatchDashboard)(DashBoard);
